import { useQuery } from 'react-query';
import { getPhotoUrl } from '../redux/modules/graphApis';
import { getMSGraphScopeAndEndPoint } from '../shared/utils';
import { MSGraphScopes } from '../shared/constants';
import { useAuth } from '@iamexperiences/feature-auth';

export const useGetUserPhoto = () => {
  const { auth } = useAuth();
  return useQuery({
    queryKey: ['getUserPhoto'],
    staleTime: Infinity,
    queryFn: async () => {
      const url = getPhotoUrl();
      const token = await auth.acquireToken({ scopes: [getMSGraphScopeAndEndPoint(MSGraphScopes.UserReadAll).scope] });
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 404) {
        return undefined;
      }

      if (!response.ok) {
        throw new Error('Failed to get user photo');
      }

      return URL.createObjectURL(await response.blob());
    },
  });
};
